import signIn from './pages/sign-in'
import signUp from './pages/sign-up'
import terms from './terms'

export default {
  terms,
  pages: {
    'sign-up': signUp,
    'sign-in': signIn,
  },
}
